import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
    return (
        <div className="d-flex justify-content-center mt-4">
            <Pagination>
                <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink previous onClick={() => onPageChange(currentPage - 1)} />
                </PaginationItem>

                {[...Array(totalPages)].map((_, index) => (
                    <PaginationItem key={index} active={currentPage === index + 1}>
                        <PaginationLink onClick={() => onPageChange(index + 1)}>
                            {index + 1}
                        </PaginationLink>
                    </PaginationItem>
                ))}

                <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink next onClick={() => onPageChange(currentPage + 1)} />
                </PaginationItem>
            </Pagination>
        </div>
    );
};

export default CustomPagination ;
